import { render } from "./TeamTargets.vue?vue&type=template&id=90654984"
import script from "./TeamTargets.vue?vue&type=script&lang=js"
export * from "./TeamTargets.vue?vue&type=script&lang=js"

import "./TeamTargets.vue?vue&type=style&index=0&id=90654984&lang=css"

import exportComponent from "C:\\Development\\konnektor\\scores\\kon-platform-wallboards-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__